/* eslint-disable import/order */
/* eslint-disable react/prop-types */
import {
  TextField,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  FormControlLabel,
  Checkbox,
  Button,
} from '@mui/material';
import React from 'react';
import PropTypes from 'prop-types';
import { dayjs } from '../../../utils/functions';
import { DatePicker } from '../../Datepicker';
import _ from 'lodash';
import UploadFile from '../CRM/UploadFile';

export function TrailerTailForm({
  errors,
  trailerTail,
  trailerTailType,
  Controller,
  control,
  watch,
  setValue,
  FileOpen,
  file,
  setFile,
  setFileOpen,
}) {
  const uploadfiletrailer = () => (
    <form>
      <UploadFile
        isOpen={FileOpen}
        files={file}
        setFiles={setFile}
        handleClose={() => setFileOpen(false)}
      />
    </form>
  );
  return (
    <div className="flex flex-row flex-wrap">
      <div className="w-full px-1 py-2">
        <Controller
          name={'licence_number'}
          control={control}
          defaultValue={trailerTail ? trailerTail.licence_number : ''}
          rules={{ required: true }}
          render={({ field }) => (
            <TextField
              {...field}
              label="ป้ายทะเบียน"
              required
              fullWidth
              size={'small'}
              multiline={true}
              helperText={errors.licence_number && 'กรุณาใส่ข้อมูล'}
            />
          )}
        />
      </div>
      <div className="w-full px-1 py-2">
        <Controller
          name={'type'}
          control={control}
          defaultValue={trailerTail ? trailerTail?.type?._id : ''}
          rules={{ required: true }}
          render={({ field }) => (
            <FormControl sx={{ minWidth: 120 }} fullWidth={true} required>
              <InputLabel id="type" size={'small'}>
                ประเภทหางรถ
              </InputLabel>
              <Select {...field} label="ประเภทหางรถ" size={'small'} fullWidth>
                {_.size(trailerTailType?.rows) ? (
                  _.map(trailerTailType.rows, (row) => (
                    <MenuItem key={row._id} value={row._id}>
                      {row.name}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem>
                    <MenuItem disabled value="">
                      <em>ไม่มีข้อมูล</em>
                    </MenuItem>
                  </MenuItem>
                )}
              </Select>
            </FormControl>
          )}
        />
      </div>
      <div className="w-full py-2 px-1 font-semibold ">เกี่ยวกับรถ</div>
      <div className="w-full md:w-1/2 px-1 py-2">
        <Controller
          name={'attribute.brand'}
          control={control}
          defaultValue={trailerTail ? trailerTail?.attribute?.brand : ''}
          rules={{ required: false }}
          render={({ field }) => (
            <TextField
              {...field}
              label="ยี่ห้อ"
              fullWidth
              size={'small'}
              helperText={errors.trailerTail?.brand && 'กรุณาใส่ข้อมูล'}
            />
          )}
        />
      </div>
      <div className="w-full md:w-1/2 px-1 py-2">
        <Controller
          name={'attribute.generation'}
          control={control}
          defaultValue={trailerTail ? trailerTail?.attribute?.generation : ''}
          rules={{ required: false }}
          render={({ field }) => (
            <TextField
              {...field}
              label="รุ่น"
              fullWidth
              size={'small'}
              helperText={errors.attribute?.generation && 'กรุณาใส่ข้อมูล'}
            />
          )}
        />
      </div>
      <div className="w-full md:w-1/2 px-1 py-2">
        <Controller
          name={'attribute.chassis_number'}
          control={control}
          defaultValue={
            trailerTail ? trailerTail?.attribute?.chassis_number : ''
          }
          rules={{ required: false }}
          render={({ field }) => (
            <TextField
              {...field}
              label="เลขคัชชี"
              fullWidth
              size={'small'}
              helperText={errors.attribute?.chassis_number && 'กรุณาใส่ข้อมูล'}
            />
          )}
        />
      </div>
      <div className="w-full md:w-1/2 px-1 py-2">
        <Controller
          name={'attribute.body_number'}
          control={control}
          defaultValue={trailerTail ? trailerTail?.attribute?.body_number : ''}
          rules={{ required: false }}
          render={({ field }) => (
            <TextField
              {...field}
              label="เลขตัวถัง"
              fullWidth
              size={'small'}
              helperText={errors.attribute?.body_number && 'กรุณาใส่ข้อมูล'}
            />
          )}
        />
      </div>
      <div className="w-full md:w-1/2 px-1 py-2">
        <Controller
          name={'attribute.buy_year'}
          control={control}
          defaultValue={trailerTail?.buy_year}
          rules={{ required: false }}
          render={({ field }) => (
            <TextField
              {...field}
              label="ปีที่ซื้อ"
              fullWidth
              size={'small'}
              helperText={errors.trailerTail?.buy_year && 'กรุณาใส่ข้อมูล'}
            />
          )}
        />
      </div>
      <div className="w-full md:w-1/2 px-1 py-2"></div>
      <div>
        <div className="mt-2">{uploadfiletrailer()}</div>
      </div>
      <div className="pt-2 pr-8 ">
        <Button
          variant="contained"
          // startIcon={<FileUploadIcon />}
          onClick={() => setFileOpen(true)}
        >
          อัพโหลดเอกสาร
        </Button>
        <div>
          {trailerTail?.file && (
            <div className="pl-4">
              <a href={trailerTail?.file?.url} target="_blank" rel="noreferrer">
                <h1 className="text-blue-600 font-bold ">
                  {trailerTail?.file?.file_name}
                </h1>
              </a>
            </div>
          )}
          {!_.isEmpty(file) && (
            <div className="pl-4">
              <h1 className="font-bold">ไฟล์ใหม่</h1>
              <h1>{file?.[0]?.name}</h1>
            </div>
          )}{' '}
        </div>
      </div>
      <div className="w-full py-2 px-1 font-semibold ">
        เกี่ยวกับ พรบ.รถยนต์
      </div>
      <div className="w-full md:w-1/2 px-1 py-2">
        <Controller
          name={'attribute.invoice_number'}
          control={control}
          defaultValue={trailerTail?.attribute?.invoice_number}
          rules={{ required: false }}
          render={({ field }) => (
            <TextField
              {...field}
              label="เลขที่ พรบ."
              fullWidth
              size={'small'}
              helperText={errors.attribute?.invoice_number && 'กรุณาใส่ข้อมูล'}
            />
          )}
        />
      </div>{' '}
      <div className="w-full md:w-1/2 px-1 py-2">
        {!watch('no_invoice_date') && (
          <Controller
            name={'attribute.invoice_date'}
            control={control}
            defaultValue={
              trailerTail?.attribute?.invoice_date
                ? dayjs(trailerTail?.attribute?.invoice_date).format(
                    'YYYY-MM-DD',
                  )
                : null
            }
            rules={{ required: false }}
            render={({ field }) => (
              <DatePicker
                {...field}
                setValue={field.onChange}
                label="วันสิ้นสุด พรบ. / วันที่ต้องต่ออายุ"
                value={field?.value}
                onChange={(e) => {
                  field.onChange(e);
                  setValue('attribute.invoice_date', null);
                }}
              />
            )}
          />
        )}
        <Controller
          name="no_invoice_date"
          control={control}
          defaultValue={
            trailerTail?.attribute
              ? !trailerTail?.attribute?.invoice_date
              : false
          }
          render={({ field }) => (
            <FormControlLabel
              label="ไม่ระบุวันสิ้นสุด พรบ. / วันที่ต้องต่ออายุ"
              control={<Checkbox {...field} defaultChecked={field.value} />}
            />
          )}
        />
      </div>
    </div>
  );
}

TrailerTailForm.propTypes = {
  errors: PropTypes.shape({
    name: PropTypes.object,
    description: PropTypes.object,
    type_code: PropTypes.object,
  }),
  trailerTail: PropTypes.object,
  watch: PropTypes.func,
  setValue: PropTypes.func,

  trailerTailType: PropTypes.object,
  Controller: PropTypes.func,
  control: PropTypes.object,
};

TrailerTailForm.defaultProps = {
  trailerTail: null,
};

export default TrailerTailForm;
